<ng-container *ngIf="loader.loading$ | async">
  <div class="loader-backdrop" aria-hidden="true"></div>
  <div class="loader-overlay" role="status" aria-label="loading">
    <div class="loader"></div>
  </div>
</ng-container>
